import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateFragment } from 'generated/resources/graphql'

import Settings from './Settings'

interface Props {
  shiftTemplate: ShiftManagementTemplateFragment
}

const TableOptions = ({ shiftTemplate }: Props) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s24" flexGrow>
      <Text.Header2>{shiftTemplate.name}</Text.Header2>
      <Settings shiftTemplate={shiftTemplate} />
    </Box>
  )
}

export default TableOptions
